import Model, { belongsTo } from '@ember-data/model';

export default class KarParametroModel extends Model {
  @belongsTo('empresa', { async: false, inverse: null }) empresa;

  // TODO: Agregar los atributos conforme se vayan necesitando. No agregar todos.
}
